import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'newArray',
})
export class NewArrayPipe implements PipeTransform {
  transform(arrayLength: number): number[] {
    return new Array(arrayLength);
  }
}
